import { HTMLAttributes } from 'react'

import Button from '@/components/base/button-more'
import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { useParagraphMotion } from './motion/paragraph'
import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type ParagraphProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    paragraph: string
    link: WPLink
  }>

const Paragraph = ({ paragraph, link, ...props }: ParagraphProps) => {
  const { motionRef } = useParagraphMotion()

  return (
    <Section ref={motionRef} {...props}>
      <Container>
        <Grid>
          <div
            className={cn(
              'col-span-2 md:col-span-4 md:col-start-3 lg:col-span-6 lg:col-start-7',
              'grid gap-y-[5rem]'
            )}
          >
            {paragraph ? (
              <Typography variant="standard" paragraph className="" data-motion-paragraph>
                {paragraph}
              </Typography>
            ) : null}

            {link && link.url ? (
              <div className="flex">
                <Button href={link.url} target={link.target}>
                  {link.title}
                </Button>
              </div>
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Paragraph
